/**
 * The edit form's chrome: the back link, the heading, the save button and the
 * error line, around the shared field set.
 *
 * Split from the page so that file holds the data and the save, and this one
 * holds what they look like.
 */
import { ArrowLeft, Save } from 'lucide-react';

import { WorkshopTypeFields, type FieldsProps } from '../WorkshopTypeFormFields';

export default function WorkshopTypeEditView({
  isNew,
  name,
  saving,
  saveError,
  fields,
  onBack,
  onSubmit,
}: {
  isNew: boolean;
  name: string;
  saving: boolean;
  saveError: string;
  fields: FieldsProps;
  onBack: () => void;
  onSubmit: (e: React.FormEvent) => void;
}) {
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <button
          onClick={onBack}
          className="p-1.5 rounded-lg text-stone-400 hover:bg-stone-100 dark:hover:bg-[#242d28]"
          title="Back"
        >
          <ArrowLeft size={16} />
        </button>
        <h2 className="text-base font-semibold text-bark-900 dark:text-stone-100">
          {isNew ? 'New Workshop Type' : name || 'Edit Workshop Type'}
        </h2>
      </div>

      <form
        onSubmit={onSubmit}
        className="bg-white dark:bg-[#1e2521] rounded-xl border border-stone-200 dark:border-stone-700 p-5 space-y-4"
      >
        <h3 className="text-xs font-semibold text-stone-500 dark:text-stone-400 uppercase tracking-wide">
          Details
        </h3>

        {saveError && (
          <div className="p-3 rounded-lg bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 text-sm">
            {saveError}
          </div>
        )}

        <WorkshopTypeFields {...fields} />

        <div className="flex justify-end pt-1">
          <button
            type="submit"
            disabled={saving || !name.trim()}
            className="flex items-center gap-2 px-4 py-2 text-sm rounded-lg bg-moss-600 text-white hover:bg-moss-700 disabled:opacity-50"
          >
            <Save size={14} />
            {saving ? 'Saving...' : isNew ? 'Create Workshop Type' : 'Save Changes'}
          </button>
        </div>
      </form>
    </div>
  );
}
